import { XMarkIcon } from '@heroicons/react/16/solid';
import { Artboard, Modal } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { useModalsContext } from '../../../../../providers/ModalsProvider/Modals.context.ts';
import { POSTER_URL, VIDEO_URL } from './ConnectionModal.constant.ts';
import useConnectionModal from './ConnectionModal.hook.ts';
import './ConnectionModal.styles.scss';
import Loader from './Loader/Loader.component.tsx';
import QrCode from './QrCode/QrCode.component.tsx';
import QrFailure from './QrFailure/QrFailure.component.tsx';

export default function ConnectionModal() {
  const { connectionModalIsOpen, setConnectionModalIsOpen } =
    useModalsContext();
  const { qrStatus, qrCode, retry } = useConnectionModal();
  const { t } = useTranslation('sidebar/sidebarComponent');

  return (
    <Modal.Legacy
      open={connectionModalIsOpen}
      onClickBackdrop={() => {
        setConnectionModalIsOpen(false);
      }}
      className="ConnectionModal w-1/2 h-70"
    >
      <Modal.Header className="ConnectionModal__Header">
        <XMarkIcon
          onClick={() => {
            setConnectionModalIsOpen(false);
          }}
          className="ConnectionModal__Icon"
        />
      </Modal.Header>
      <Modal.Body className="ConnectionModal__Body">
        <div className="ConnectionModal__Body__Element ConnectionModal__Body__Element--left">
          <h1>{t('page.modals.connection.title')}</h1>
          <ol>
            <li>{t('page.modals.connection.step1')}</li>
            <li>{t('page.modals.connection.step2')}</li>
            <li>{t('page.modals.connection.step3')}</li>
            <li>{t('page.modals.connection.step4')}</li>
          </ol>
          <video
            src={VIDEO_URL}
            autoPlay
            loop
            muted
            poster={POSTER_URL}
          ></video>
        </div>
        <div className="ConnectionModal__Body__Element ConnectionModal__Body__Element--right">
          <Artboard className="ConnectionModal__Artboard bg-base-200">
            {qrStatus === 'failed' ? (
              <QrFailure onRetry={retry} />
            ) : qrStatus === 'ready' ? (
              <QrCode qr_code={qrCode} />
            ) : (
              <Loader />
            )}
          </Artboard>
        </div>
      </Modal.Body>
    </Modal.Legacy>
  );
}
